// Canonical "where does this role live" map — the home route each role lands on
// after login. SINGLE SOURCE OF TRUTH, reused by the post-login redirect
// (pages/Login.js) and the forbidden-route guard (components/ProtectedRoute.js)
// so an authenticated user who hits a route their role can't open is sent to
// THEIR OWN dashboard, never bounced to "/" → "/login" (which cleared the
// session and looked like a random logout — e.g. a super_admin clicking a
// notification whose link pointed at a client-only route).

const ROLE_HOME = {
  super_admin: '/admin',
  admin: '/admin',
  process_manager: '/admin',
  accountant: '/accountant',
  case_officer: '/officer',
  client: '/client',
  sales_consultant: '/sales',
  sales_manager: '/sales/manager',
  marketing_manager: '/admin/marketing',
  legal_counsel: '/legal',
  // B2B partner — their own portal, never the admin shell. Without this
  // entry the role falls through to '/login', which clears the session and
  // reads to the partner as a broken account on their very first sign-in.
  b2b_partner: '/partner',
};

// Home path for a role. Falls back to '/login' only for an unknown/missing role
// (i.e. no valid session to honour).
export function roleHome(role) {
  return ROLE_HOME[role] || '/login';
}
